import React, { useRef, useState } from 'react'
import map from '../img/map.png'
import Style from './Contact.module.css'
import { MDBBtn } from 'mdb-react-ui-kit';
import { Col, Container, Row } from 'react-bootstrap';
import emailjs from '@emailjs/browser';


const Contact = () => {

    const [panding, setpanding] = useState(false)

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        setpanding(true);

        emailjs.sendForm('service_ji4zve1', 'template_gw0p2vi', form.current, 'EM-SjE80AhYzyRDVK')
            .then((result) => {
                setpanding(false);
                alert("we've recieved your message!")
                console.log(result.text);
                form.current.reset()
            }, (error) => {
                setpanding(false);
                alert("sorry, there was some error!")
                console.log(error.text);
                form.current.reset()
            });
    };


    return (
        <>


            {/* <a href="https://wa.me/919313696550">watt</a> */ }

            <div class={ Style.loader }></div>
            <center><h3>Location</h3></center>
            <div className={ Style.map }>
                <img src={ map } alt="" />
            </div>

            <center>  <h1>contact</h1></center>



            <Container>
                <Row>
                    <Col lg={ 6 } xl={ 6 } md={ 6 }>
                        <div className='d-flex justify-content-center align-items-center w-100'>
                            <img className='w-100' src="https://pbs.twimg.com/media/CsvQlWqWIAA6UAm?format=jpg&name=4096x4096" alt="" />

                        </div>
                    </Col>

                    <Col lg={ 6 } xl={ 6 } md={ 6 }>

                        <form className='p-3' ref={ form } onSubmit={ sendEmail }>

                            <label htmlFor="" className='d-block'>NAME</label>
                            <input type="text" required className='w-100' name='name' />

                            <label htmlFor="" className='d-block'>MOBILE NO</label>
                            <input type="number" required className='w-100' name='mobilenumber' />

                            <label htmlFor="" className='d-block'>E-MAIL</label>
                            <input type="email" required className='w-100' name='email' />

                            <label htmlFor="" className='d-block'>MESSAGE</label>
                            <textarea id="" className='w-100' required name="message" ></textarea>


                            <MDBBtn color="primary" type='submit' disabled={ panding ? true : false } >{ panding ? "Loding..." : "send message" }</MDBBtn>

                        </form>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Contact
